import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import i18n from './i18n';
import utility from './ctUtility';
import axios from 'axios';
import VueAxios from 'vue-axios';

import '@/assets/css/mystyle.css';

import CtSponsors from "@/layouts/commons/CtSponsors.vue";
import CtFooterCommons from "@/layouts/commons/CtFooter.vue";
import CtLoadingCommons from "@/layouts/commons/CtLoading.vue";
import CtUserInfoCommons from "@/layouts/commons/CtUserInfo.vue";
import CtDialogCommons from "@/layouts/commons/CtDialog.vue";
import CtNavBar from "@/layouts/commons/CtNavBar.vue";
import CtToolbar from "@/layouts/commons/CtToolbar.vue";

import CtMainLayoutLanding from "@/layouts/landing/CtLayoutFull.vue";
import CtMainLayoutLogin from "@/layouts/landing/CtLayoutLogin.vue";

//import CtToolbarAppGui from "@/layouts/appgui/CtToolbar.vue";
import CtMainLayoutAppGui from "@/layouts/appgui/CtLayoutFull.vue";

//import CtToolbarAppCommerciale from "@/layouts/appcommerciale/CtToolbar.vue";
import CtLayoutFullAppCommerciale from "@/layouts/appcommerciale/CtLayoutFull.vue";

//import CtToolbarAppAdmin from "@/layouts/appadmin/CtToolbar.vue";
import CtLayoutFullAppAdmin from "@/layouts/appadmin/CtLayoutFull.vue";

import * as VueGoogleMaps from 'vue2-google-maps';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';
 
if(process.env.NODE_ENV === 'production')
{
  Vue.use(VueGoogleMaps, {
    load: { key: 'AIzaSyD4AOJ4AwBIP4teUSYgoQC-_KA4vy7nR08', libraries: 'places'},
  });
} 
else 
{
  Vue.use(VueGoogleMaps, {
    load: {
      libraries: 'places', // This is required if you use the Autocomplete plugin
      // OR: libraries: 'places,drawing'
      // OR: libraries: 'places,drawing,visualization'
      // (as you require)
  
      //// If you want to set the version, you can do so:
      // v: '3.26',
    },
  });
}

//=== COMPONENTI GENERALI
Vue.component('ct-sponsors', CtSponsors);

Vue.component('ct-footer', CtFooterCommons);
Vue.component('ct-dialog', CtDialogCommons);
Vue.component('ct-loading', CtLoadingCommons);
Vue.component('ct-user-info', CtUserInfoCommons);
Vue.component('ct-navbar', CtNavBar);
Vue.component('ct-main-layout-landing', CtMainLayoutLanding);
Vue.component('ct-main-layout-login', CtMainLayoutLogin);
Vue.component('ct-toolbar', CtToolbar);

Vue.component('ct-main-layout-appgui', CtMainLayoutAppGui);

Vue.component('ct-main-layout-appcommerciale', CtLayoutFullAppCommerciale);

Vue.component('ct-main-layout-appadmin', CtLayoutFullAppAdmin);

Vue.config.productionTip = false
Vue.use(VueAxios, axios);
Vue.use(utility);

// AXOIS GLOBAL CONFIG - INTERCEPTOR PER AVERE LA RESPONSE NEL MSG DI ERRORE
axios.interceptors.response.use( (response) => { return response; }, function (error) { 
	try {
    //alert("itercetto");
    //alert(JSON.stringify(error.response));
    return error.response;
	} catch(err) {
		return error;
	} 
});


//=== OGGETTO MIXIN 
//=== QUI SI DEFINISCONO METODI DATI GLOBALI
Vue.mixin(utility);

//=== OGGETTO ROOT
var rootApp = new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  i18n,
  data: () => ({
    loading: false,
    globalPageLoading: false,
    changesNotSavedFlg: false,
    changesNotSavedConfirmDialog: {open: false, destinationName: ''},
  }),
  computed: 
	{
    simpleLoadingGuard() { 
      return (this.loading == true && this.globalPageLoading == false);
    },
    globalLoadingGuard() { 
      return this.globalPageLoading;
		}, 
  },
  methods: {
    doLogout() {
      this.dialogMsgOpen = false;
      this.dialogMsg = "";
      this.setUser(null);
      this.goToPage("/");	
    },
    tokenExpired() { 
      this.setDialogMsg(i18n.t('err.tokenExpired'));
      this.doLogout();
    },
		goToPage(relativePath){ 
			router.replace(relativePath); 
    },
		catchGenericError(err){
			console.log(err);
			this.setDialogMsg(i18n.t('err.generic'));
    },
    changeLocale(langSelected) {
			i18n.locale  = langSelected;
			events.$emit(constants.EVENT_CHANGE_LOCALE);
    },
    genericGetCallEngine(endpoint2go, cbFun, errorlabel = 'err.generic') 
    {
      if(cbFun != null)
      {
        this.loading = true;
        this.axios
          .get(endpoint2go)
          .then(response => {rootApp.myAxiosThenWithCbfun(response, cbFun, errorlabel); })
          .catch(error => {rootApp.myAxiosError(error, errorlabel)});
      }  
      else 
      {
        this.setDialogMsg("CALLBACK NOT VALID");
      }
    },
    genericGetAuthenticatedCallEngine(endpoint2go, cbFun, errorlabel = 'err.generic') 
    {
      if(cbFun != null)
      {
        this.loading = true;
        var myUser = this.getUser();
        this.axios
          .get(endpoint2go, this.getMyAuthHeader(myUser))
          .then(response => {rootApp.myAxiosThenWithCbfun(response, cbFun, errorlabel); })
          .catch(error => {rootApp.myAxiosError(error, errorlabel)});
      }  
      else 
      {
        this.setDialogMsg("CALLBACK NOT VALID");
      }
    },
    genericPostAuthenticatedCallEngine(endpoint2go, obj2send, cbFun, errorlabel = 'err.generic') 
    {
      if(cbFun != null)
      {
        this.loading = true;
        var myUser = this.getUser();
        this.axios
          .post(endpoint2go, obj2send, this.getMyAuthHeader(myUser))
          .then(response => {rootApp.myAxiosThenWithCbfun(response, cbFun, errorlabel); })
          .catch(error => {rootApp.myAxiosError(error, errorlabel)});
      }  
      else 
      {
        this.setDialogMsg("CALLBACK NOT VALID");
      }
    },
    genericPutAuthenticatedCallEngine(endpoint2go, obj2send, cbFun, errorlabel = 'err.generic') 
    {
      if(cbFun != null)
      {
        this.loading = true;
        var myUser = this.getUser();
        this.axios
          .put(endpoint2go, obj2send, this.getMyAuthHeader(myUser))
          .then(response => {rootApp.myAxiosThenWithCbfun(response, cbFun, errorlabel); })
          .catch(error => {rootApp.myAxiosError(error, errorlabel)});
      }  
      else 
      {
        this.setDialogMsg("CALLBACK NOT VALID");
      }
    },
    genericPatchAuthenticatedCallEngine(endpoint2go, obj2send, cbFun, errorlabel = 'err.generic') 
    {
      if(cbFun != null)
      {
        this.loading = true;
        var myUser = this.getUser();
        if(obj2send != null)
        {
          this.axios
            .patch(endpoint2go, obj2send, this.getMyAuthHeader(myUser))
            .then(response => {rootApp.myAxiosThenWithCbfun(response, cbFun, errorlabel); })
            .catch(error => {rootApp.myAxiosError(error, errorlabel)});
        } 
        else 
        {
          this.axios
            .patch(endpoint2go, this.getMyAuthHeader(myUser))
            .then(response => {rootApp.myAxiosThenWithCbfun(response, cbFun, errorlabel); })
            .catch(error => {rootApp.myAxiosError(error, errorlabel)});
        }
      }  
      else 
      {
        this.setDialogMsg("CALLBACK NOT VALID");
      }
    },
    genericDeleteAuthenticatedCallEngine(endpoint2go, cbFun, errorlabel = 'err.generic') 
    {
      if(cbFun != null)
      {
        this.loading = true;
        var myUser = this.getUser();
        this.axios
          .delete(endpoint2go, this.getMyAuthHeader(myUser))
          .then(response => {rootApp.myAxiosThenWithCbfun(response, cbFun, errorlabel); })
          .catch(error => {rootApp.myAxiosError(error, errorlabel)});
      }  
      else 
      {
        this.setDialogMsg("CALLBACK NOT VALID");
      }
    },
    myAxiosThenWithCbfun(response, cbFun, errorlabel){
      try{
        if(response.status == 200)
        {	
            // CALL BACK
            cbFun(response.data);
        } 
        else if(response.status == 401)
        {
            this.tokenExpired();
            this.globalPageLoading = false;
        } 
        else 
        {
          if(this.isEmptyString(errorlabel))
          {
            errorlabel = 'err.generic';
          }
          this.setDialogMsg(i18n.t(errorlabel));
          this.globalPageLoading = false;
        }
      } 
      finally { 
        this.loading = false;
      }			
    },
    myAxiosError(error, errorlabel)
    {
      this.loading = false;
      this.globalPageLoading = false; 
      if(this.isEmptyString(errorlabel))
      {
        errorlabel = 'err.generic';
      }
      this.setDialogMsg(i18n.t(errorlabel));
      console.log(error);
    }, 
  },
  render: h => h(App)
});